export var RegistrationSettingProgramType;
(function (RegistrationSettingProgramType) {
    RegistrationSettingProgramType["Tournament"] = "TOURNAMENT";
    RegistrationSettingProgramType["Legacy"] = "LEGACY";
    RegistrationSettingProgramType["TournamentGroupedProgram"] = "TOURNAMENT_GROUPED_PROGRAM";
})(RegistrationSettingProgramType || (RegistrationSettingProgramType = {}));
